import { idForMap } from "./identifiers";
import { CoordinateUnit, MapPath, TopicData } from "./schema/v1";

interface MakeMapPathOptions {
  lineColor?: string;
  label?: string;
  coordinateUnits?: { lat?: CoordinateUnit; lon?: CoordinateUnit };
  visible?: boolean;
}

/**
 * The single place a {@link MapPath} is built, so its `id` is derived
 * consistently from the data (via {@link idForMap}) wherever a path is created.
 * Color and label are passed in because that policy differs per caller.
 */
export function makeMapPath(
  data: TopicData[],
  options: MakeMapPathOptions = {},
): MapPath {
  return {
    id: idForMap(data),
    data,
    visible: options.visible ?? true,
    ...(options.coordinateUnits !== undefined
      ? { coordinateUnits: options.coordinateUnits }
      : {}),
    style: {
      ...(options.lineColor !== undefined
        ? { lineColor: options.lineColor }
        : {}),
      ...(options.label !== undefined ? { label: options.label } : {}),
    },
  };
}

/**
 * Collapse MapPaths that share an id, keeping the first, so a panel never holds
 * duplicate ids — which would break removal (remove-by-id) and React list keys.
 */
export function dedupeMapPaths(paths: MapPath[]): MapPath[] {
  const seen = new Set<string>();
  return paths.filter((path) => {
    if (seen.has(path.id)) {
      return false;
    }
    seen.add(path.id);
    return true;
  });
}
